import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {PunteggioComponent} from './punteggio.component';


const routes: Routes = [{
  path:'',
  component: PunteggioComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PunteggioRoutingModule { }
